export default __webpack_public_path__ + "static/brand-image-b7bae96ec2c25f04a0ad77be25497d2c.jpg";